import { useQuery } from '@tanstack/react-query';
import { financeApi } from '@/api/finance';

/**
 * KPI snapshot pour la période donnée (courante par défaut).
 * refetchInterval 60s : le backend recalcule à chaque validate/pay + cron 15min,
 * un poll 60s garantit que même sans mutation locale (ex: DG dans autre filiale
 * valide une facture) le dashboard reflète la nouvelle valeur < 1 min.
 */
export const useFinanceKpis = (periode?: string) =>
  useQuery({
    queryKey: ['finance', 'kpis', periode ?? 'current'],
    queryFn:  () => financeApi.getKpis(periode),
    staleTime:              30_000,
    refetchInterval:        60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus:   true,
  });

/**
 * Historique 6 mois pour le graphique d'évolution.
 * Cache 5 min — l'historique change moins souvent que le snapshot courant.
 * Refetch 5 min (mois précédents figés, seul le mois courant bouge).
 */
export const useFinanceKpisHistory = (months = 6) =>
  useQuery({
    queryKey: ['finance', 'kpis', 'history', months],
    queryFn:  () => financeApi.getKpisHistory(months),
    staleTime:       2 * 60_000,
    refetchInterval: 5 * 60_000,
  });
